/**
 *  Service for convert units of Measure (m3 => ft3) etc.
 */

var VRC = VRC || {};
VRC.ConversionUnitService = (function(){
  var _conversionUnits;
  var init = function(conversionUnits){
    _conversionUnits = conversionUnits;

   };

  function roundToTwo(num) {
    return +(Math.round(num + "e+2")  + "e-2");
  }

  var getConversionUnit = function(unit){
    return _.find(_conversionUnits, function(conversionUnit){
       return conversionUnit.unit === unit;
    });
  };

  var getWeight = function(value, from, to){
     to = to || 'mt';


    var toObj =  getConversionUnit(to);
     if(!toObj){
       return value;

     }
    var toCof = toObj.coefficientFactor;
    var fromObj = getConversionUnit(from);

    var fromCof = fromObj.coefficientFactor;


    return roundToTwo(value * (fromCof / toCof));

  };



  return {
    init : init,
    getWeight : getWeight
  }
})();
